import type { BaseDictionaryItem } from './dictionaryUtils'

/** Type for phone number dictionary items. */
export type PhoneNumberTypeItem = BaseDictionaryItem

/** Phone number types dictionary. */
export const PHONE_NUMBER_TYPES: readonly PhoneNumberTypeItem[] = [
  { key: 'MOBILE', label: 'Mobile', localeKey: 'ui.entities.comms.phoneNumberType.mobile' },
  {
    key: 'FIXED_LINE',
    label: 'Fixed Line',
    localeKey: 'ui.entities.comms.phoneNumberType.fixedLine'
  },
  {
    key: 'FIXED_LINE_OR_MOBILE',
    label: 'Fixed Line or Mobile',
    localeKey: 'ui.entities.comms.phoneNumberType.fixedLineOrMobile'
  },
  { key: 'TOLL_FREE', label: 'Toll Free', localeKey: 'ui.entities.comms.phoneNumberType.tollFree' },
  {
    key: 'PREMIUM_RATE',
    label: 'Premium Rate',
    localeKey: 'ui.entities.comms.phoneNumberType.premiumRate'
  },
  {
    key: 'SHARED_COST',
    label: 'Shared Cost',
    localeKey: 'ui.entities.comms.phoneNumberType.sharedCost'
  },
  { key: 'VOIP', label: 'VOIP', localeKey: 'ui.entities.comms.phoneNumberType.voip' },
  {
    key: 'PERSONAL_NUMBER',
    label: 'Personal Number',
    localeKey: 'ui.entities.comms.phoneNumberType.personalNumber'
  },
  { key: 'PAGER', label: 'Pager', localeKey: 'ui.entities.comms.phoneNumberType.pager' },
  { key: 'UAN', label: 'UAN', localeKey: 'ui.entities.comms.phoneNumberType.uan' },
  {
    key: 'VOICEMAIL',
    label: 'Voice Mail',
    localeKey: 'ui.entities.comms.phoneNumberType.voicemail'
  },
  { key: 'UNKNOWN', label: 'Unknown', localeKey: 'ui.entities.comms.phoneNumberType.unknown' },
  { key: 'ERROR', label: 'ERROR', localeKey: 'dev.dataMappingError', icon: 'bug', color: 'error' }
] as const
